module.exports = __webpack_public_path__ + "static/media/ChronicleSSm-Medium_Web.8c93280d.woff2";